var Vue = require('vue');
var Columnator = require('../../lib/columnator.js');
var IndexView = require('../../lib/index-view.js');
var FundsAllocationsList = require('./components/FundsAllocationsList').default;

module.exports = function() {
    const fundsList = new Vue({
        el: '#funds-list',
        components: {
            'funds-list': FundsAllocationsList
        }
    });

    $(document).one('pjax:end', () => {
        fundsList.$destroy();
    });
    new Columnator();
    new IndexView();
};
